import { Injectable } from '@angular/core';

/**
 * Faro initializes lazily (guarded by isPlatformBrowser - see app.component.ts)
 * so window.faro doesn't exist yet for a while after the app boots. Every
 * pushEvent call in the app goes through this service instead of touching
 * window.faro directly, so ANY event fired before Faro is ready gets queued
 * and flushed once it is - not just the route-level funnel events in
 * app.component.ts (same class of bug flagged on v2.buupass.com's PR #499
 * review, Juliet Wambuku: "Only route events use the queue" - search_submitted,
 * trip_selected, payment_submitted, booking_completed and the rest were still
 * calling window.faro directly).
 */
@Injectable({ providedIn: 'root' })
export class FaroService {
  private ready = false;
  private queue: Array<{ name: string; attrs: Record<string, unknown> }> = [];

  /** Called once from app.component.ts after initializeFaro() resolves. */
  markReady(): void {
    this.ready = true;
    this.queue.splice(0).forEach(({ name, attrs }) => this.send(name, attrs));
  }

  pushEvent(name: string, attrs: Record<string, unknown> = {}): void {
    try {
      if (this.ready) {
        this.send(name, attrs);
      } else {
        this.queue.push({ name, attrs });
      }
    } catch (e) { /* analytics must never break the app */ }
  }

  private send(name: string, attrs: Record<string, unknown>): void {
    try {
      (window as any).faro?.api?.pushEvent(name, attrs);
    } catch (e) { /* analytics must never break the app */ }
  }
}
